<template>
  <div class="text-center m-x-1">
    <!-- TODO (Volkan): fix this -->
    <vk-icon
        name="hammersaw"
        size="70"
        class="c-depot"
        selenium="hammer-saw-icon"/>
    <div class="text-hero" selenium="welcome-text-label">Welcome</div>
    <span class="h6 c-gray50" selenium="welcome-message-label">
      You will be able to discuss further details on this screen and update Job Status.
    </span>
  </div>
</template>

<script>
export default {
  name: 'message-empty',
  props: {
    job: {
      type: Object,
      required: true,
    },
  },
  computed: {
    firstName () {
      return this.job.customer.first_name;
    },
  },
};
</script>
